<template>
  <subtitle>Create Contact</subtitle>

  <div v-if="errorMessage" class="alert alert-danger" role="alert">
    {{ errorMessage }}
  </div>

  <div v-if="successMessage" class="alert alert-success" role="alert">
    {{ successMessage }}
  </div>

  <div v-if="model" class="h-100">
    <div class="pt-3">
      <div class="row">
        <div class="col-sm-12 col-md-10 col-lg-10">
          <card label="Contact Details">
            <edit-fields :v="v$" />
          </card>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12 col-md-10 col-lg-10">
      <div class="form-group d-grid gap-2 d-md-flex justify-content-md-end">
        <router-link class="btn btn-secondary float-right btn-lg" type="button" :to="parentRoute">
          <span>Cancel</span>
        </router-link>

        <smart-submit-large label="Save" :loading="loading" @click="save" />
      </div>
    </div>
  </div>
</template>

<script>
import { Subtitle, SmartSubmitLarge } from '@trustmark-2005-ltd/trustmark-shared-components';
import useValidate from '@vuelidate/core';
import EditFields from './SchemesEditContactsFields.vue';
import { validationModel } from './validation-model';

export default {
  name: 'SchemesEditContactsCreate',
  components: {
    SmartSubmitLarge,
    EditFields,
    Subtitle,
  },
  data() {
    return {
      loading: false,
      errorMessage: null,
      successMessage: null,
      v$: useValidate(),
    };
  },
  computed: {
    parentRoute() {
      return `/scheme/${this.$route.params.schemeId}/edit/contacts`;
    },
    model() {
      return this.$store.state.schemeContact.contact;
    },
  },
  methods: {
    save() {
      this.v$.$validate();
      if (this.v$.$error) {
        window.scrollTo(0, 0);
        this.errorMessage =
          'Unable to save the contact. Please resolve any errors on this form and try again.';
        return;
      }

      const payload = this.model;
      payload.schemeId = this.$route.params.schemeId;
      this.$store
        .dispatch('schemeContact/createContact', payload)
        .then((resp) => {
          this.$store
            .dispatch('schemeContact/listContacts', this.$route.params.schemeId)
            .then(() => {
              this.successMessage = resp;
              this.$router.push(this.parentRoute);
            });
        })
        .catch((err) => {
          window.scrollTo(0, 0);
          this.loading = false;
          this.errorMessage =
            (err.response && err.response.data && err.response.data.message) ||
            err.message ||
            err.toString();
        });
    },
  },
  validations: {
    model: validationModel,
  },
};
</script>
